import {
  SemanticsList,
  ThemeTokensSemantic,
  useThemeTokensSemantic,
} from "shared/theme/sidespor/theme/themeSemantics";
import { SystemStyleObject } from "shared/theme/sidespor/types";

/**
 * We cant use semantics="xxx" on TableRow directly since its a slot of Table.
 * Therefore we add css code that activates if TableRow has data-semantics="xxx"
 */
export const defineDataSemantics = (
  definitionFunction: (theme: ThemeTokensSemantic) => SystemStyleObject,
) =>
  Object.fromEntries(
    SemanticsList.map((semantic) => {
      const themeSemantic = useThemeTokensSemantic(semantic);
      return [
        `&[data-semantic='${semantic}']`,
        definitionFunction(themeSemantic),
      ];
    }),
  );
